import { Injectable } from "@angular/core";
import { FeatureToggleService } from '@nx-fe/services';

// Tracks some performance on RC related code
@Injectable({ providedIn: 'root' })
export class PerformanceService {
    // Screen update performance settings
    screenUpdateExpectedTimeframe = 30; // We 'expect' to receive at lease a screen update every 10 seconds
    screenUpdateWarningTimer: NodeJS.Timeout = null;

    // Screen refresh performance settings
    canvasDrawExpectedTimeframe = 30; // We 'expect' to refresh the RC canvas at least every 10 seconds
    canvasDrawWarningTimer: NodeJS.Timeout = null;

    private _performanceEnabled?: boolean = null;   // Enables/Disables performance tracking (currently based on featureToggle DeveloperMode)
    private _currentRcDevice: string = null;        // The device currently being RCed

    constructor(private featureToggleService: FeatureToggleService) { }

    // isPerformanceEnabled() {
    //     // Only load it if it was not already
    //     if (this._performanceEnabled === null) {
    //         this._performanceEnabled = this.featureToggleService.isEnabled("DeveloperMode") === true; // === true to make it boolean and not null
    //     }
    //     return this._performanceEnabled;
    // };

    get isRcPerformanceEnabled() {
        // return this.isPerformanceEnabled() && this._currentRcDevice != null;
        // Disabling this as there are no current issues this could be useful for, and just clutters the console
        return false;
    };

    screenPackageReceived(fullscreen: boolean) {
        if (this.isRcPerformanceEnabled) {
            this.screenUpdateWarningTimer = this.refreshTimer(
                this.screenUpdateWarningTimer,
                () => {
                    console.warn('[Performance]', this.loggableTimeStampString(), 'Its been', this.screenUpdateExpectedTimeframe, 'seconds without screen updates.');
                },
                this.screenUpdateExpectedTimeframe * 1000);

            if (fullscreen) {
                console.log('[Performance]', this.loggableTimeStampString(), 'RC:FULL_SCREEN');
            } else {
                // Commenting it for now as it clutters the console
                // console.log('[Performance]', this.loggableTimeStampString(), 'RC:DELTA_SCREEN');
            }
        }
    };

    canvasDrawn() {
        if (this.isRcPerformanceEnabled) {

            this.canvasDrawWarningTimer = this.refreshTimer(
                this.canvasDrawWarningTimer,
                () => {
                    console.warn('[Performance]', this.loggableTimeStampString(), 'Its been', this.canvasDrawExpectedTimeframe, 'seconds without drawing the RC canvas.');
                },
                this.canvasDrawExpectedTimeframe * 1000
            );
        }
    };

    rcSessionStarted(deviceId: string) {
        this._currentRcDevice = deviceId;
    };

    rcSessionEnded(deviceId: string) {
        if (deviceId !== this._currentRcDevice) {
            console.warn('[Performance] Inconsistent state of the device being RCed: (', deviceId, 'vs', this._currentRcDevice);
        }
        // we are not RCing any more, so we should stop tracking rc performance
        this._currentRcDevice = null;

        // Clear the intervals...
        if (this.screenUpdateWarningTimer != null) {
            clearInterval(this.screenUpdateWarningTimer);
            this.screenUpdateWarningTimer = null;
        }
        if (this.canvasDrawWarningTimer != null) {
            clearInterval(this.canvasDrawWarningTimer);
            this.canvasDrawWarningTimer = null;
        }
    };

    private loggableTimeStampString() {
        const date = new Date();
        return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + ':' + date.getMilliseconds();
    };

    private refreshTimer(interval: NodeJS.Timeout, action: (...args: any[]) => void, timespan: number): NodeJS.Timeout {
        if (interval !== null) {
            clearInterval(interval);
        }
        return setInterval(action, timespan);
    };
}
